import React from 'react';
var OpenInNewTab = function (props) {
    var isElectron = !!window.electron;
    function handleClick(event) {
        props.onClick && props.onClick();
        if (window.electron) {
            event.preventDefault();
            window.electron.send('browser/openLink', { url: props.href });
        }
    }
    return (React.createElement("a", { href: props.href, className: "".concat(props.className || '', " ").concat(props.noUnderline ? '' : 'text-underline'), target: 'blank', onClick: handleClick }, props.children));
};
export default OpenInNewTab;
